// Set href for menu button + remove data-attributes
const navBtn = document.querySelector("#navHeaderDonateBtn");

navBtn.setAttribute("href", "https://am.ticketmaster.com/tsutigers/quick-donate/MTIz");
navBtn.setAttribute("target", "_blank");
navBtn.removeAttribute("data-bs-toggle");
navBtn.removeAttribute("data-bs-target");
